import { useEffect } from "react";

import { Typography } from "@mui/material";
import { Link, Navigate, useParams } from "react-router-dom";

import { useWhiteScreen } from "../../../hooks/useWhiteScreen";
import { Container } from "../../common/Container/Container";
import { CreateYourProfile } from "./CreateYourProfile";
import { FindingTheTrainingServicesThatHelpYouThrive } from "./FindingTheTrainingServicesThatHelpYouThrive";
import { HowToDeliverAGreatService } from "./HowToDeliverAGreatService";
import { OrkaAppInstallationGuide } from "./OrkaAppInstallationGuide";
import { PersonalBrandAmbassadorProgram } from "./PersonalBrandAmbassadorProgram";

import "./resources.scss";

export const resources = [
	{
		slug: "finding-the-training-services-that-help-you-thrive",
		title: "Finding the training services that help you thrive",
		renderComponent: FindingTheTrainingServicesThatHelpYouThrive,
	},
	{
		slug: "personal-brand-ambassador-program",
		title: "Personal Brand Ambassador Program",
		renderComponent: PersonalBrandAmbassadorProgram,
	},
	{
		slug: "how-to-deliver-a-great-service",
		title: "How to Deliver a Great Service?",
		renderComponent: HowToDeliverAGreatService,
	},
	{
		slug: "create-your-profile",
		title: "Create your profile",
		renderComponent: CreateYourProfile,
	},
	{
		slug: "fly-orka-app-installation-guide",
		title: "Fly ORKA App Installation Guide",
		renderComponent: OrkaAppInstallationGuide,
	},
];

export function Resources() {
	useWhiteScreen();
	const params = useParams();
	const resourceSlug = params.resourceSlug;

	useEffect(() => {
		const hash = location.hash;
		if (hash && resourceSlug) {
			const id = hash.slice(1);
			document.getElementById(id)?.scrollIntoView();
		}
	}, [resourceSlug]);

	if (resourceSlug) {
		const foundResource = resources.find(
			(resource) => resource.slug === resourceSlug,
		);
		if (!foundResource) {
			return <Navigate to="/resources" replace />;
		}

		return <foundResource.renderComponent />;
	}

	return (
		<Container
			navbarOrkaProps={{ white: true }}
			className="resources-container">
			<Typography className="title-text bold" textAlign="center">
				Resources
			</Typography>
			{resources.map((resource, index) => (
				<div className="spacing-top" key={resource.slug}>
					<Link
						className="normal-text underline-on-hover-link black-text"
						to={`/resources/${resource.slug}`}>
						{`${index + 1}. ${resource.title}`}
					</Link>
				</div>
			))}
		</Container>
	);
}
